import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import StatusBadge from "../components/StatusBadge";
import { AlertTriangle } from "lucide-react";

export default function Correction() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/dashboard/correction-journal").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-overline mb-1">{t("correction_journal")}</div>
        <h1 className="font-heading font-black text-4xl tracking-tight">
          Korreksiya Jurnalı
        </h1>
        <p className="text-slate-600 mt-2">
          Geri qaytarılan və korreksiya tələb edilən sorğular
        </p>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-lg p-12 text-center">
          <AlertTriangle className="w-12 h-12 mx-auto text-slate-300 mb-3" />
          <p className="text-slate-500">{t("no_data")}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((i) => (
            <Link
              key={i.id}
              to={`/inspections/${i.id}`}
              className="block bg-white border border-slate-200 rounded-lg p-4 hover:border-[#FF5722] hover:shadow-sm transition-all"
              data-testid={`correction-${i.id}`}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="mono text-xs text-slate-500">
                  #{i.id.slice(0, 8)} · Parent #{i.parent_request_id?.slice(0, 8)}
                </div>
                <StatusBadge status={i.status} />
              </div>
              <p className="text-sm">{i.description}</p>
              <div className="mono text-[10px] text-slate-400 mt-2">
                {new Date(i.created_at).toLocaleString()}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
